<!-- TEXTBOX -->
@if (entry.base?.display) {
  <form [connect]="'payloadStates.' + entry?.formControlAttributes?.connectPath" [formGroup]="form">
    <mat-form-field appearance="outline" [style]="selectStyle">
      <mat-label>{{entry?.formControlAttributes?.label}}@if (entry?.formControlAttributes?.required) {
        <span style="color: #a71919;">*</span>
      }</mat-label>
      <mat-select [formControlName]="entry.formControlAttributes.formControlName"
        [id]="entry.formControlAttributes.connectPath + '-' + formControlName"
        [compareWith]="trackPlanComparison">
        @for (option of availablePlans; track option) {
          <mat-option [value]="option">{{option.productName}}</mat-option>
        }
      </mat-select>
      <mat-spinner matSuffix [diameter]="25" [hidden]="!isLoadingPlans"></mat-spinner>
      @if (!entry?.formControlAttributes?.disabled) {
        <mat-hint><em>Plan selection requires a zip code, product group, and plan year</em></mat-hint>
      }
    </mat-form-field>
    @if (formControls[entry.formControlAttributes.formControlName]?.errors?.required && !noPlansError) {
      <mat-error>Required</mat-error>
    }
    @if (noPlansError) {
      <mat-error>No plans were found with the specified criteria</mat-error>
    }
  </form>
}
